/**
 * Add-to-cart DÙNG CHUNG (common) — mọi nút [data-ink-add-cart] trên mọi trang.
 *
 * Hành vi thống nhất (đồng bộ theo carousel マイプリンター — top-user-menu):
 *   - AJAX POST /cart/add.js, KHÔNG reload trang
 *   - Feedback: nút 追加中... khi đang gửi → MODAL "カートに追加しました" on success
 *     (modal global = snippet cart-added-modal, mở qua [data-ink-cart-modal]).
 *     Lỗi → khôi phục nút, KHÔNG modal.
 *   - NGOẠI LỆ màn cart: trang dựng lại ngay nên modal chỉ kịp nháy — thay bằng
 *     highlight dòng vừa thêm (banner 新しく商品が追加されました) do cart.js dựng.
 *   - Dispatch `ink:cart:updated` → cart-count.js cập nhật số lượng nút header
 *
 * Contract markup (mọi card add-to-cart phải theo):
 *   <button type="button" data-ink-add-cart data-variant-id="123">カートに入れる</button>
 *   Số lượng (optional):
 *     - data-quantity trên nút (ưu tiên cao nhất), HOẶC
 *     - [data-qty-val] trong tổ tiên gần nhất [data-ink-cart-item]
 *     - mặc định 1
 *
 * Qty stepper dùng chung: [data-qty-dec] / [data-qty-inc] cập nhật [data-qty-val]
 *   trong cùng [data-ink-cart-item].
 *
 * Event delegation trên document → áp dụng cả nút render động (carousel JS).
 * Fail-silent: lỗi network chỉ log + khôi phục nút, KHÔNG crash.
 */
(function () {
  'use strict';

  const ADD_DONE_MS = 1500;

  // Modal "カートに追加しました" dùng chung (snippet cart-added-modal, global trong
  // theme.liquid). Mở on success; đóng qua × / 買い物を続ける / backdrop / Escape.
  // Màn cart tự dựng lại sau khi thêm hàng → modal bật lên bị reload nuốt ngay.
  // Ở đó cart.js highlight dòng vừa thêm thay cho modal (1:1 site cũ: cờ
  // `addCart=true` → class `added-cart`, shop.cart.php:186-190).
  const isCartPage = () => !!document.querySelector('[data-ink-cart]');
  const CART_ADDED_KEY = 'ink_cart_added_key';

  function openCartModal() {
    if (isCartPage()) return;
    const modal = document.querySelector('[data-ink-cart-modal]');
    if (!modal) return;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    modal.setAttribute('aria-hidden', 'false');
  }

  // Modal add-to-cart là COMMON toàn site. Các JS add-to-cart RIÊNG (collection.js,
  // product-detail.js, carousel, mypage...) dispatch `ink:cart:added` sau khi
  // /cart/add.js OK → mở CÙNG 1 modal (đồng nhất mọi trang). (KHÁC ink:cart:updated
  // = refresh header count / reload cart page.)
  document.addEventListener('ink:cart:added', openCartModal);

  function closeCartModal() {
    const modal = document.querySelector('[data-ink-cart-modal]');
    if (!modal) return;
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    modal.setAttribute('aria-hidden', 'true');
  }

  // [data-qty-val] có thể là SPAN (textContent) hoặc INPUT (value — gõ tay
  // được, kiểu category card / add-to-cart-block). Hỗ trợ cả 2 dạng.
  function readQty(valEl) {
    const raw = valEl.tagName === 'INPUT' ? valEl.value : valEl.textContent;
    return Math.max(1, parseInt(raw, 10) || 1);
  }

  function writeQty(valEl, qty) {
    if (valEl.tagName === 'INPUT') {
      valEl.value = String(qty);
    } else {
      valEl.textContent = String(qty);
    }
  }

  // Số lượng: data-quantity > [data-qty-val] trong [data-ink-cart-item] > 1.
  function resolveQuantity(btn) {
    if (btn.dataset.quantity != null && btn.dataset.quantity !== '') {
      return Math.max(1, parseInt(btn.dataset.quantity, 10) || 1);
    }
    const item = btn.closest('[data-ink-cart-item]');
    const valEl = item && item.querySelector('[data-qty-val]');
    if (valEl) return readQty(valEl);
    return 1;
  }

  async function addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    const quantity = resolveQuantity(btn);
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '追加中...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
      });
      if (!res.ok) throw new Error('cart add failed ' + res.status);
      // Phải ghi TRƯỚC khi dispatch: cart.js reload ngay khi nhận event.
      if (isCartPage()) {
        const json = await res.json().catch(() => null);
        const key = json && json.items && json.items[0] && json.items[0].key;
        // Kèm variantId: đổi số quà làm giỏ dựng lại và line key có thể đổi theo,
        // lúc đó cart.js dò lại dòng bằng variant.
        try {
          sessionStorage.setItem(CART_ADDED_KEY, JSON.stringify({ key: key || '', variant: String(variantId) }));
        } catch (e) { /* private mode → mất highlight, vẫn thêm được hàng */ }
      }
      document.dispatchEvent(new CustomEvent('ink:cart:updated'));
      // Khôi phục nút ngay + mở modal feedback (thay inline 追加しました cũ)
      btn.disabled = false;
      btn.textContent = original;
      openCartModal();
    } catch (err) {
      console.error('[cart-add] add to cart', err);
      btn.textContent = original;
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = original;
      }, ADD_DONE_MS);
    }
  }

  // Stepper +/− chỉnh [data-qty-val] cục bộ trong từng card.
  function stepQuantity(stepBtn) {
    const item = stepBtn.closest('[data-ink-cart-item]');
    const valEl = item && item.querySelector('[data-qty-val]');
    if (!valEl) return;
    const cur = readQty(valEl);
    const next = stepBtn.hasAttribute('data-qty-inc') ? cur + 1 : Math.max(1, cur - 1);
    writeQty(valEl, next);
  }

  document.addEventListener('click', (e) => {
    const stepBtn = e.target.closest('[data-qty-dec], [data-qty-inc]');
    if (stepBtn) {
      stepQuantity(stepBtn);
      return;
    }
    // Đóng modal: nút × / 買い物を続ける / click ra backdrop
    if (e.target.closest('[data-ink-cart-modal-close]')) {
      closeCartModal();
      return;
    }
    if (e.target.matches('[data-ink-cart-modal]')) {
      closeCartModal();
      return;
    }
    const addBtn = e.target.closest('[data-ink-add-cart]');
    if (addBtn) {
      e.preventDefault(); // chặn submit nếu nút lỡ nằm trong <form>
      addToCart(addBtn);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartModal();
  });
})();
